module.exports = __webpack_public_path__ + "static/media/piyush-goel-02.5578a125.jpg";